(function() {
  'use strict';

  // Cache frequently accessed values
  var dataLayer = window.dataLayer = window.dataLayer || [];
  var pageContext = null;

  // Helper function to add event listeners with delegation (passive for better scroll perf)
  function addDelegatedEvent(selector, eventType, callback, options) {
    document.addEventListener(eventType, function(e) {
      var target = e.target.closest(selector);
      if (target) {
        callback.call(target, e);
      }
    }, options || { passive: true });
  }

  // Helper function to get page context (cached)
  function getPageContext() {
    if (!pageContext) {
      pageContext = {
        page_title: document.title,
        page_location: document.location.href,
        page_path: document.location.pathname
      };
    }
    return pageContext;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {

    // ============== Yotpo Review Submission Tracking ==============
    addDelegatedEvent('.yotpo-new-review-submit', 'click', function() {
      var form = this.closest('form, .yotpo-review-form, .yotpo-form');
      if (!form) return;

      var ratingTextEl = form.querySelector('.yotpo-star-rating-text');
      var validationEl = form.querySelector('.yotpo-new-input-validation');
      
      var ratingText = ratingTextEl ? ratingTextEl.textContent.trim() : '';
      var validationText = validationEl ? validationEl.textContent.trim() : '';
      
      var hasRating = ratingText !== '';
      var noErrors = validationText === '';

      if (hasRating && noErrors) {
        dataLayer.push(Object.assign({
          event: "review_submission"
        }, getPageContext()));
      }
    });

    // ============== ShopPay CTA Click Tracking ==============
    addDelegatedEvent('#paymentterms', 'click', function() {
      dataLayer.push(Object.assign({
        event: "cta_click",
        click_text: "Check your purchasing power",
        click_url: window.location.href
      }, getPageContext()));
    });

    // ============== PDP Accordion Click Tracking ==============
    addDelegatedEvent('.product-tabs-header-item', 'click', function() {
      var clickText = this.textContent.trim();
      
      dataLayer.push(Object.assign({
        event: "accordian_click",
        click_text: clickText
      }, getPageContext()));
    });

    // ============== Yotpo Add Your Own Click Tracking ==============
    addDelegatedEvent('.yotpo-pictures-gallery-upload-button', 'click', function() {
      var clickText = this.textContent.trim() || 'Add Your Own';
      
      dataLayer.push(Object.assign({
        event: "cta_click",
        click_text: clickText
      }, getPageContext()));
    });

    // ============== Yotpo Trademark Link Click Tracking ==============
    addDelegatedEvent('.yotpo-reviews-trademark, .yotpo-reviews-by', 'click', function() {
      dataLayer.push(Object.assign({
        event: "cta_click",
        click_text: "Trusted reviews by Yotpo"
      }, getPageContext()));
    });

    // ============== Ignite Your Story Carousel Click Tracking ==============
    // Desktop: .y-hover-elements | Mobile: .y-image-overlay
    addDelegatedEvent('.y-hover-elements, .y-image-overlay', 'click', function() {
      var wrapper = this.closest('.y-image-wrapper') || this;
      var img = wrapper.querySelector('img');
      var productName = img ? img.getAttribute('alt') || '' : '';
      
      dataLayer.push(Object.assign({
        event: "carousel_banner_click",
        product_name: productName
      }, getPageContext()));
    });

    // ============== Similar Products Click Tracking ==============
    addDelegatedEvent('.ProductList--carousel .ProductItem a[href*="/products/"]', 'click', function() {debugger;
      var productItem = this.closest('.ProductItem');
      var toSku = '';
      
      if (productItem) {
        toSku = productItem.getAttribute('data-product-sku') || '';
        if (!toSku) {
          var skuEl = productItem.querySelector('[data-sku]');
          toSku = skuEl ? skuEl.getAttribute('data-sku') || '' : '';
        }
      }
      
      var fromSku = window.currentProductSku || '';
      
      dataLayer.push(Object.assign({
        event: "similar_products",
        from_sku: fromSku,
        to_sku: toSku
      }, getPageContext()));
    });

    // ============== Floating Add to Cart Tracking ==============
    addDelegatedEvent('#form-sticky button[data-action="add-to-cart"], .sticky-item button[data-action="add-to-cart"], .action.sticky-item button[type="submit"]', 'click', function() {
      var form = this.closest('form');
      var prActiveEl = document.querySelector('.pr-active');
      var selectedVariantText = prActiveEl ? prActiveEl.textContent.trim() : '';
      
      var price = window.currentProductPrice || 0;
      var priceMatch = selectedVariantText.match(/\$[\d,.]+/);
      var variantPrice = priceMatch ? parseFloat(priceMatch[0].replace('$', '').replace(',', '')) : price;
      var variantName = selectedVariantText.split(' - $')[0] || selectedVariantText;
      
      var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
      var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      dataLayer.push({
        event: "floating_add_to_cart",
        ecommerce: {
          currency: window.shopCurrency || "USD",
          value: variantPrice,
          items: [{
            item_id: window.currentProductSku || '',
            item_name: window.currentProductTitle || '',
            item_category: window.currentProductType || '',
            item_variant: variantName,
            price: variantPrice,
            quantity: quantity
          }]
        }
      });
    });
  } 
})();